import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { InspectionSchema } from '../entities/inspection.js';
export const EndInspectionApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    response: InspectionSchema,
};
export const EndInspectionRequestSchema = EndInspectionApiSchema.params.merge(EndInspectionApiSchema.headers);
